// @ts-ignore
import { env } from '@/src/env'
import posthog from 'posthog-js'
import create, { type GetState, type Mutate, type SetState, type StoreApi } from 'zustand'
import { devtools, persist } from 'zustand/middleware'
import type { UserFrontendDto } from '../api/types/generated-types/types.gen'
import type { User } from '../types/user'
import { clearEmberThreadsFromStorage } from './useEmberThread.hook'

const persistKey = {
  name: 'store:session',
  getStorage: () => localStorage,
}

// TODO: replace any
// TODO: Check and remove all this, zustand handles this automatically.
export const getLocalStorageSessionValue = (key: string): null | string | boolean | Partial<StoreUserType & { email: string }> => {
  try {
    const state = localStorage.getItem('store:session')
    if (!state) return null
    const json = JSON.parse(state)

    return json.state[key]
  } catch (e) {
    return null
  }
}

export type StoreUserType = Omit<UserFrontendDto, 'customDashboardLayout'> & {
  customDashboardLayout: any[]
  pgId: number
  companyName: string
  companyFirebaseId: string
  organizationId: string | null
}

interface SessionStore {
  user: StoreUserType | null
  isLoggedIn: boolean | null
  refreshToken: string | null
  token: string | null
  setSession: (newSession: {
    user?: User | null
    isLoggedIn?: boolean | null
    refreshToken?: string | null
    token?: string | null
  }) => void
  updateUserInStore: (updatedUser: Partial<StoreUserType>) => void
  logout: () => void
}

// this any makes sense, we just want to pass the whole function
const devtoolsOnDevelopment = env.isDev ? devtools : (persistReturn: any) => persistReturn

export const useSessionStore = create<
  SessionStore,
  SetState<SessionStore>,
  GetState<SessionStore>,
  Mutate<StoreApi<SessionStore>, [['zustand/persist', Partial<SessionStore>]]>
>(
  devtoolsOnDevelopment(
    persist(
      (set, get: any) => ({
        user: getLocalStorageSessionValue('user'),
        isLoggedIn: getLocalStorageSessionValue('isLogged'),
        refreshToken: getLocalStorageSessionValue('refreshToken'),
        token: getLocalStorageSessionValue('token'),
        setSession: (newSession: Partial<SessionStore>) => set({ ...newSession }),
        updateUserInStore: (userUpdateData: Partial<StoreUserType>) => {
          const currentUser = get().user
          if (currentUser) {
            set({ user: { ...currentUser, ...userUpdateData } })
          }
        },
        logout: () => {
          set({ user: null, isLoggedIn: false, refreshToken: null, token: null })
          posthog.reset()
          localStorage.clear()
          clearEmberThreadsFromStorage()
          window.location.reload()
        },
      }),
      persistKey
    )
  )
)
